import '@fontsource/inter'
import '@fontsource/inter/500.css'
import '@fontsource/inter/400.css'
import ThemeProvider from '@mui/material/styles/ThemeProvider'
import { LicenseInfo } from '@mui/x-data-grid-pro'
import { QueryClient, type QueryClientConfig, QueryClientProvider } from '@tanstack/react-query'
import '@total-typescript/ts-reset'
import DefaultMaterialTheme from 'helpers/DefaultMaterialTheme'
import ReactDOM from 'react-dom'
import App from './App'
import './index.css'
import dayjs from 'dayjs'
import en from 'dayjs/locale/en'
import tz from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'
import ErrorBoundary from './routes/errorBoundary'
import { GlobalStyles } from './styles/globalStyles'

// dayjs.locale({ ...en, weekStart: 1 })
dayjs.extend(utc)
dayjs.extend(tz)

LicenseInfo.setLicenseKey(
  '3b8bfac2c85b55e3178f786568ac2733Tz0xMTM1NjcsRT0xNzg4MDQ3OTk5MDAwLFM9cHJlbWl1bSxMTT1zdWJzY3JpcHRpb24sUFY9aW5pdGlhbCxLVj0y',
)

const ReactQueryOptions: QueryClientConfig = {
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      cacheTime: 0,
      retry: false,
    },
  },
}

const Root = () => (
  <ThemeProvider theme={DefaultMaterialTheme}>
    <ErrorBoundary>
      <QueryClientProvider client={new QueryClient(ReactQueryOptions)}>
        <GlobalStyles />
        <App />
      </QueryClientProvider>
    </ErrorBoundary>
  </ThemeProvider>
)

ReactDOM.render(<Root />, document.getElementById('root'))
